import { GripVertical } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { useSortableItemContext } from './context';

export function DragHandle({ className }: { className?: string }) {
  const { handleRef } = useSortableItemContext();

  return (
    <button
      className={twMerge(
        className,
        'dark:text-accent-x-light mb-1 cursor-grab rounded-xl p-1.5 opacity-40 hover:bg-gray-200 hover:opacity-100 dark:hover:bg-gray-900'
      )}
      ref={handleRef}
      type="button"
    >
      <GripVertical size={16} />
    </button>
  );
}
